import { createApi } from '@reduxjs/toolkit/query/react';
import { graphqlBaseQuery } from './graphqlBaseQuery';

export const api = createApi({
  baseQuery: graphqlBaseQuery,
  // endpoints are added using "injectEndpoint" by the rtk query/graphql code gen
  endpoints: () => ({}),
});
